var cov_2dhhva6xkm = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tooltip/styles/index.ts",
      hash = "b8989700991cb3ce155aa05878ae32f115bf77de",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tooltip/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 28
        },
        end: {
          line: 5,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var tooltipLess = {};
import genaration from '../../utils/classname';
export var tooltipClass = (cov_2dhhva6xkm.s[0]++, genaration(tooltipLess, 'tooltip'));